export type SmartLockProvider = 'TTLOCK';

export enum BookingPasscodeStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export interface BookingPasscodeInfo {
  status: BookingPasscodeStatus;
  passcode: string | null;
  validFrom: string;
  validTo: string;
}

export interface SmartLockSettingsResponse {
  provider: SmartLockProvider;
  username: string;
  passcodeValidityBreathingRoomInMinutes: number;
}

export interface UpsertSmartLockSettingsRequest {
  provider: SmartLockProvider;
  username: string;
  password?: string;
  passwordMd5?: string;
  passcodeValidityBreathingRoomInMinutes: number;
}

export interface SmartLockSummary {
  lockId: number;
  lockName: string;
  keyboardPwdVersion: number;
  electricQuantity: number;
  hasGateway: number;
  groupId?: number;
  groupName?: string;
}

export interface LinkRoomToSmartLockRequest {
  lockId: number;
  lockName: string;
}

export interface LinkedRoomLockResponse {
  provider: SmartLockProvider;
  externalLockId: number;
  externalLockName: string;
}

export interface LinkedRoomSummary {
  roomId: string;
  roomName: string;
}

export interface LinkedRoomsByLockResponse {
  provider: SmartLockProvider;
  externalLockId: number;
  externalLockName: string;
  rooms: LinkedRoomSummary[];
}

export interface GenerateSmartLockPasscodeRequest {
  roomId: string;
  startTime: string;
  endTime: string;
}

export interface GenerateSmartLockPasscodeResponse {
  passcode: string;
  validityStartTime: string;
  validityEndTime: string;
}
